import React, { ReactNode } from 'react';
import Select from 'react-select';

import {
  CmFormControl,
  CmFormLabel,
  ReactSingleSelectInput,
} from '@/components/uiParts';
import { reactSelectStyle } from '@/components/uiParts/Form/Select/ReactSelect/style';

interface Props {
  fontWeight?: 'bold' | 'normal';
  width?: string;
  isClearable?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  closeMenuOnSelect?: boolean;
  label: string;
  name: string;
  singleSelectInput?: ReactSingleSelectInput;
  error?: ReactNode;
}

export const CmLabelAndSingleReactSelect: React.FC<Props> = ({
  fontWeight = 'normal',
  width = '100%',
  isClearable = true,
  isRequired = false,
  isInvalid = false,
  closeMenuOnSelect = false,
  label,
  name,
  singleSelectInput,
  error,
  children,
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel {...{ fontWeight, isRequired }}>{label}</CmFormLabel>
      <Select
        name={name}
        {...{ ...singleSelectInput, closeMenuOnSelect, isClearable }}
        styles={{
          ...reactSelectStyle,
        }}
      />
      {error}
      {children}
    </CmFormControl>
  );
};
